import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface ManageCarriersInterface {
  warehouseOrderIds: any
  carrierDetail: {
    carrierProvider?: string
    serviceCarrier?: string
    serviceType?: string
    atl?: boolean
    isPriority?: boolean
  }
}

export const useManageCarriers = () => {
  const mutate = useMutation(
    ({ warehouseOrderIds, carrierDetail }: ManageCarriersInterface) => {
      return postAPI(`PWBulkConsignment/ManageCarriers`, {
        warehouseOrderIds: warehouseOrderIds.map(
          (order: { id: any }) => order.id,
        ),
        carrierDetail: {
          carrierProvider: carrierDetail?.carrierProvider,
          serviceCarrier: carrierDetail?.serviceCarrier,
          serviceType: carrierDetail?.serviceType,
          atl: carrierDetail?.atl,
          isPriority: carrierDetail?.isPriority,
        },
      })
    },
  )

  return mutate
}

export default useManageCarriers
